import cookiesFN from './cookies';
import imprintFN from './imprint';
import privacyFN from './privacy';
import termsFN from './termsofuse';
import otConfig from './otConfig';
import gaConfig from './ga';
import { getGAKey } from 'helpers/googleAnalitics/GAandGTM';
import getStaticUrl from 'helpers/staticContent';

const { ga: gaId, gtm } = getGAKey(gaConfig);

export default {
  ga: gaId,
  gtm,
  title: 'Fnac',
  landingImg: `${getStaticUrl()}/my-customer-space/Landing_BM.png`,
  favicon: `${getStaticUrl()}/my-customer-space/FN_favicon.ico`,
  keyLoginConfig: 'birthDate',
  langs: ['en', 'es', 'fr', 'de', 'it', 'nl'],
  defaultLang: 'en',
  faq: [
    { from: 1, to: 19, notShowed: [8, 13] },
    { from: 20, to: 28, notShowed: [21, 22, 23, 24, 25, 28] },
    { from: 29, to: 47 },
  ],
  cookies: cookiesFN,
  imprint: imprintFN,
  privacy: privacyFN,
  terms: termsFN,
  logo: {
    src: `${getStaticUrl()}/my-customer-space/FNAC_Logo.svg`,
    alt: 'FNAC',
    width: '194.56px',
  },
  footerlogo: {
    src: `${getStaticUrl()}/my-customer-space/FNAC_Logo.svg`,
    alt: 'Footer FNAC',
  },
  company: 'bolttech',
  otScript: otConfig,
  footer: [
    {
      label: 'terms_of_use',
      link: '/terms-of-use',
    },
    {
      label: 'imprint',
      link: '/imprint',
    },
    {
      label: 'faq',
      link: '/faq',
    },
  ],
};
